import { render } from "./SeatMap.vue?vue&type=template&id=38050f96&scoped=true"
import script from "./SeatMap.vue?vue&type=script&lang=js"
export * from "./SeatMap.vue?vue&type=script&lang=js"

import "./SeatMap.vue?vue&type=style&index=0&id=38050f96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38050f96"]])

export default __exports__